<template>
  <div class="select-image sel-image"  @keyup.enter="searchEnterFun">
    <div class="select-info">
      <div class="select-left sli">
        <ul>
          <li><span>检查时间：</span>
            <pDate class="date" ref="getdate" @query="query"></pDate>
          </li>
          <li><span>患者信息：</span>
            <el-input
              placeholder="患者姓名"
              v-model="patientName"
              clearable>
            </el-input>
            <el-input
              placeholder="患者编号/检查编号"
              v-model="checkNumber"
              clearable>
            </el-input>
          </li>
          <li style="width:550px;"><span>所在院区：</span>
            <el-select v-model="hospitalName" clearable placeholder="本院">
                 <el-option
                v-for="item in hos"
                :key="item.hosId"
                :label="item.hosName"
                :value="item.hosId">
              </el-option>
            </el-select>
            <!-- <el-select
              class="biaoji"
              v-model="biaoji"
              multiple
              collapse-tags
              placeholder="报告标记">
              <el-option
                v-for="item in options"
                :key="item.catalogCode"
                :label="item.catalogName"
                :value="item.catalogCode">
              </el-option>
            </el-select> -->
            <el-checkbox v-model="checkRead">读片</el-checkbox>
          </li>
        </ul>
      </div>
      <div class="select-right">
        <div class="doc-type">
          <em class="label">就诊类别:</em>
          <el-checkbox-group v-model="checkDoc" class="DocGroup">
            <el-checkbox-button v-model="checkDoc" value="" label="" key="所有" @change="handleDocAllchange">所有</el-checkbox-button>
            <el-checkbox-button v-for="(doc,index) in docs" :label="doc" :key="doc" @change="handleDocChange">{{docslabel[index]}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <div class="check-type">
          <em class="label">检查类型:</em>
          <el-checkbox-group v-model="checkType" class="CheckGroup">
            <el-checkbox-button v-model="checkType" value="" label="" key="所有" @change="handleCheckedAllchange">所有</el-checkbox-button>
            <el-checkbox-button v-for="check in checks" :label="check" :key="check" @change="handleCheckedChange">{{check}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
      </div>
      <a class="aBtn" id="search" @click="getTime" >查询</a>
    </div>

    <zTable :head="head"  v-loading="loading"  :data="ReportList" :studyList="studyList" :height="300" :operationWidth="'60px'" :operation="operation" @_operation="_operation_" ref="getSelection" @selection="submitSelection" :dynamicOperationName="'imageSelect'"></zTable>
    <page :total="totals" :allPage="allPages" :currentPage="currentPages" @current-page="currentPage" @page-size="pageSize"></page>
    <!--确定取消按钮-->
      <!--<btns @clickbtn="clickbtn" ></btns>-->
    <!--<table></table>-->
    <div class="button_content">
      <el-button @click="submit(true)" class="alone_button">{{text}}</el-button>
      <el-button @click="submit(false)" class="esc_button">{{esctext}}</el-button>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import zTable from '@/components/common/tables/selectTable'
  import pDate from '@/components/common/date/selectDate'
  import page from '@/components/common/page/page'
  import btns from '@/components/common/button/buttons'
  import http from '@/api/http'
  import * as _ from '@/common/js/config'
  import {cookies} from '@/api/util'
  import {nomalTime} from '@/common/js/time'
  import {message} from '@/common/js/messages'
  import {changehosArea,changeAge,changeGender,changeSex,changeclinicType,changecheckType} from '@/common/js/change'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  const checks = ['DX/DR/CR', 'CT', 'MR', 'RF', 'XA', 'US', 'ES'];
  const docslabel = ['门诊', '住院', '急诊', '体检' , '预约'];
  const docs = ['50', '10', '60', '70', '90'];

  export default {
    components: {
      pDate,
      zTable,
      btns,
      page
    },
    watch: {
      ReportList(c, o) {
        for (let item of c) {
          if (item.caseSex === 'F' || item.caseSex === '0') {
            item.caseSex = '女'
          } else {
            item.caseSex = '男'
          }
        }
      }
    },
    /*props: [
      'Select'
    ],*/
    props: {
      text: {
        type: String,
        default: "确定"
      },
      esctext: {
        type: String,
        default: "取消"
      },
      studyList: {
        type: Array,
        default() {
          return []
        }
      },
      videosearchVal: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        //recordNumber: '',
        patientName: '',
        checkNumber: '',
        checkRead:'',
        hosArea: '',
        hospitalName:'',
        checkType: [''],
        checks: checks,
        loading:false,
        checkDoc: [''],
        docs: docs,
        docslabel: docslabel,

        hos: [],
          // {
          //   value: '',
          //   label: '全部院区'
          // }, {
          //   value: '0',
          //   label: '解放院区'
          // }, {
          //   value: '4',
          //   label: '滨江院区'
          // },

        head: [
          {
            props: 'hospitalName',
            label: '医院名称'
          },{
            props: 'patientId',
            label: '患者编号'
          },{
            props: 'accessionNumber',
            label: '检查编号'
          },{
            props: 'examTypeName',
            label: '类型'
          },
          {
            props: 'patientName',
            label: '姓名'
          },
          {
            props: 'patientSex',
            label: '性别'
          },
          {
            props: 'patientAge',
            label: '年龄'
          },
          {
            props: 'clinicType',
            label: '就诊类别'
          },
          {
            props: 'examBodyName',
            label: '检查项目'
          },
          {
            props: 'examDate',
            label: '检查时间'
          },
          {
            props: 'studyPk',
            label: 'Studypk'
          }
        ],
        ReportList: [
          /*{
            hosArea: '解放军区',
            mediId: '20111111',
            accessionNumber: '705217',
            examTypeName: 'DR',
            patientName: '张志',
            patientSex: '男',
            patientAge: '25',
            hPatientType: '门诊',
            examBodyName: '胸部侧位',
            examDate: '2017-09-09 12:25',
            readFilmFlag:'0',
          },
          {
            hosArea: '解放军区2',
            mediId: '20111111',
            accessionNumber: '705217',
            examTypeName: 'DR',
            patientName: '张志',
            patientSex: '男',
            patientAge: '25',
            hPatientType: '门诊',
            examBodyName: '胸部侧位',
            examDate: '2017-09-09 12:25',
            readFilmFlag:'1',
          },*/
        ],
        operation: [
          {
            operation: '',
            class: 'icon-dupian',
            class2: 'icon-yidupian',
            title:"读片标记"
          }
        ],
        biaoji:[],
        options: [/*{
          catalogCode: '1',
          catalogName: '肿瘤'
        }, {
          catalogCode: '2',
          catalogName: '血友病'
        }, {
          catalogCode: '3',
          catalogName: '肺结核'
        }, {
          catalogCode: '4',
          catalogName: '脑部胶质瘤'
        }, {
          catalogCode: '5',
          catalogName: '腰椎间盘突出'
        }*/],
        params: {    //params保存上一次的选择状态 初始为空
          examStartDate: '',
          examEndDate: '',
          serviceModalities: '',
          clinicType: '',
          patientName: '',
          searchNum: '',
          readFilmFlag: "",
         // hosArea: "",  //院区
         hospitalName:"",
         currentPage: "1",
          pageSize: "30",    //一页多少条
        },
        //初始
        totals: 0,   //总条目
        currentPages: 0,

        allPages: 0,   //总页数
      }
    },
    mounted() {
          let sandData={
              hosName:''
          }
        http.post('/system/findHosListOfRegion.json', sandData).then(res =>{
              this.hos= res.data.model;
              this.hos.forEach(item => {
                  this.hos.item= item.hosId
                })
      })
    },
    methods: {
      pageSize(val) {
        this.params.pageSize = val
        this.pagequery()
      },
      currentPage(val) {
        this.params.currentPage = val
        this.pagequery()
      },
      handleCheckedAllchange(val){
        this.checkType = val ? [''] : [];
        // console.log(this.checkType)
      },
      handleCheckedChange(value){
        let index = this.checkType.indexOf(String(''));
        if(index!= -1){
          this.checkType.splice(index, 1)
        }
        if(!value){
          if(this.checkType.length == 0){
            this.checkType = ['']
          }
        }
        // console.log(this.checkType)
      },
      handleDocAllchange(val){
        this.checkDoc = val ? [''] : [];
        // console.log(this.checkDoc)
      },
      handleDocChange(value){
        let index = this.checkDoc.indexOf(String(''));
        if(index!= -1){
          this.checkDoc.splice(index, 1)
        }
        if(!value){
          if(this.checkDoc.length == 0){
            this.checkDoc = ['']
          }
        }
        // console.log(this.checkDoc)
      },
      _operation_(payload) {
        if (payload.operation === 'icon-yuepian') {   //????????
        } else if (payload.operation === 'icon-yichu') {
          this.$confirm('是否确定要移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
          })
        }
        if (payload.operation === 'icon-dupian') {   //payload.operation ==='icon-yidupian'||
          if (this.ReportList[payload.index].readFilmFlag == '0'||this.ReportList[payload.index].readFilmFlag == undefined) {
            this.$confirm('是否确定标记该病例?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              //****处理
              let params = {
                hospitalId: this.ReportList[payload.index].hospitalId,
                studyPk: this.ReportList[payload.index].studyPk,
                studyUid: this.ReportList[payload.index].studyUid,
                readFilmFlag:"1",    //标记为0 传1
              };
              http.post('/edu/readFilmFlag.json', params).then(res => {
                if (res.data.code == "0000") {
                  this.ReportList[payload.index].readFilmFlag = "1";
                }
              }).catch(() => {
              })
            })
          } else {
            this.$confirm('是否确定要取消标记?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              //****处理
              let params = {
                hospitalId: this.ReportList[payload.index].hospitalId,
                studyPk: this.ReportList[payload.index].studyPk,
                studyUid: this.ReportList[payload.index].studyUid,
                readFilmFlag:"0",    //标记为0 传1
              };
              http.post('/edu/readFilmFlag.json', params).then(res => {
                if (res.data.code == "0000") {
                  this.ReportList[payload.index].readFilmFlag = "0";
                }
              }).catch(() => {
              })
            })
          }
        }
      },

      submit(val){
       if(val===true) {
         this.$refs.getSelection.getList();
         // this.$emit('statistics', tNumber)
       } else {
         this.$emit( '_popClose', false)
       }
      },
      searchEnterFun(e) {
           let keyCode = window.event? e.keyCode:e.which
           if(keyCode == 13){
              this.getTime()
           }
      },
      getTime() {
        this.$refs.getdate.getDate();
      },
      getDay(day){
        var today = new Date();

        var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;

        today.setTime(targetday_milliseconds); //注意，这行是关键代码

        var tYear = today.getFullYear();
        var tMonth = today.getMonth();
        var tDate = today.getDate();
        tMonth = this.doHandleMonth(tMonth + 1);
        tDate = this.doHandleMonth(tDate);
        return tYear+"-"+tMonth+"-"+tDate;
      },
      doHandleMonth(month){
        var m = month;
        if(month.toString().length == 1){
          m = "0" + month;
        }
        return m;
      },
      checkSearchNum(){
        message('未查询到符合条件记录',false);
        return;
      },

      pagequery() {    //请求table
        let param = this.params;
        http.post('/edu/qualityImagesList.json', param).then(res => {
          if (res.data.code == _.ERR_OK) {
            this.ReportList = [];
            for (let i = 0; i < res.data.model.length; i++) {
              res.data.model[i].examDate = nomalTime(res.data.model[i].examDate);
              res.data.model[i].patientSex = changeGender(res.data.model[i].patientSex);

              //res.data.model[i].hosArea = changehosArea(res.data.model[i].hosArea);
              res.data.model[i].clinicType = changeclinicType(res.data.model[i].clinicType);
              if(res.data.model[i].patientAge  ==undefined){
                  res.data.model[i].patientAge = ''
             }else{
                   res.data.model[i].patientAge  = res.data.model[i].patientAge
              }
                this.ReportList.push(res.data.model[i]);
              }
            this.totals = res.data.totalItem;
            this.allPages = res.data.totalPage;
            this.currentPages = res.data.currentPage;
          }
        }).catch(() => {
        })
      },
      submitSelection(val){
        this.$emit( '_popshow', val)
      },
      query(emitDate) {   //查询列表
        let param = {};
        let readFilmFlags;
        this.checkRead == true ? readFilmFlags = "1" : readFilmFlags = "";  //转成字符串
        param = this.params = {
          examStartDate: emitDate.fDate,
          examEndDate: emitDate.aDate,
          serviceModalities: changecheckType(this.checkType).join(','),
          clinicType: this.checkDoc.join(','),
          patientName: this.patientName,
          searchNum: this.checkNumber,
          readFilmFlag: readFilmFlags,
          hospitalName: this.hospitalName,  //院区
          //查询列表的currentPage，pageSize默认为空
          currentPage: "",  //当前页
          pageSize: this.params.pageSize,    //一页多少条
        }
        this.loading = true ;
        http.post(`/edu/qualityImagesList.json?${Math.random()}`, param).then(res => {
          if(res.data.totalItem==0) {
            this.checkSearchNum();
          }
          if (res.data.code == _.ERR_OK) {
            this.loading = false;
            this.ReportList = [];
            for (let i = 0; i < res.data.model.length; i++) {
              res.data.model[i].examDate = nomalTime(res.data.model[i].examDate);
              res.data.model[i].patientSex = changeGender(res.data.model[i].patientSex);
             // res.data.model[i].hosArea = changehosArea(res.data.model[i].hosArea);
              res.data.model[i].clinicType = changeclinicType(res.data.model[i].clinicType);
              res.data.model[i].hospitalName =res.data.model[i].hospitalName;
              res.data.model[i].patientId=res.data.model[i].patientId;
               if(res.data.model[i].patientAge  ==undefined){
                  res.data.model[i].patientAge = ''
               }else{
                    res.data.model[i].patientAge = res.data.model[i].patientAge

              }
              this.ReportList.push(res.data.model[i]);
            }
            this.totals = res.data.totalItem;
            this.allPages = res.data.totalPage;
            this.currentPages = res.data.currentPage;
          }
        }).catch(() => {
        })
      },
    },
    created() {
      this.checkNumber = this.videosearchVal
      this.ReportList = this.studyList
      let param ={
        examStartDate: '',
        examEndDate: '',
        pageSize: "30",
      }
      if(this.checkNumber) {
        param = {
          examStartDate: '',
          examEndDate: '',
          serviceModalities: '',
          clinicType: '',
          patientName: '',
          searchNum: this.checkNumber,
          readFilmFlag: "",
         // hosArea: "",  //院区
           hospitalName:"",
          currentPage: "",
          pageSize: "30",    //一页多少条
        }
      }
      param.examStartDate = this.getDay(-31);
      param.examEndDate = this.getDay(0);
      http.post('/edu/qualityImagesList.json', param).then(res => {
        if (res.data.code == _.ERR_OK) {
          this.ReportList = [];
          for (let i = 0; i < res.data.model.length; i++) {
            res.data.model[i].examDate = nomalTime(res.data.model[i].examDate);
            res.data.model[i].patientSex = changeGender(res.data.model[i].patientSex);
           // res.data.model[i].hosArea = changehosArea(res.data.model[i].hosArea);
            res.data.model[i].clinicType = changeclinicType(res.data.model[i].clinicType);

            if(res.data.model[i].patientAge  == undefined) {
                res.data.model[i].patientAge = ''
            }else{
              res.data.model[i].patientAge  = res.data.model[i].patientAge
            }


            this.ReportList.push(res.data.model[i]);
          }
          this.totals = res.data.totalItem;
          this.allPages = res.data.totalPage;
          this.currentPages = res.data.currentPage;
            let Date ={};
            Date.aDate = this.getDay(0);
            Date.fDate = this.getDay(-31);
            this.$refs.getdate.setDate(Date);
        }
      }).catch(() => {
      })
    }
  }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'

  .select-image
    background:$color-background-d
    height: auto
    padding-left:10px
    margin-top: -30px
    .select-info
      position:relative
      .aBtn
        display: inline-block
        height: 30px
        line-height: 30px
        text-align: center
        color: $color-background-d
        -webkit-border-radius: 3px
        -moz-border-radius: 3px
        border-radius: 3px
        position: absolute
        right: 0
        bottom: 10px
        width: 80px
        background: $color-background-hover
        z-inde:20
        cursor:pointer
    h1
      line-height: 30px
    .select-info
      overflow: hidden
      .select-left
        width: 450px
        float: left
        height:160px
        ul
          li
            height: 40px
            line-height: 40px
      .select-right
        width: 450px
        float: right
        position: relative

  .submit-btn
    width: 100%
    text-align: center
    margin-top: 20px
    a
      width: 100px
    #confirm
      background: $color-background-hover
      margin-right: 40px
    #cancel
      background: $button-del



  .check-type
  .doc-type
    height: 32px
    line-height: 32px
    width: 100%
    color: #000
    .DocGroup
    .CheckGroup
      float:left
      width:370px
    em
      font-style: normal
      width: 66px
      height: 32px
      margin-right: 10px
      float: left
    label
      min-width:34px
      cursor: pointer
  .btn-box
    text-align: center
    margin : 10px 0
    .save, .cancel
      width: 180px
      height: 35px
      border : none
      color : $button-text-color
    .save
      background : $color-background-hover
      margin-right: 80px
    .cancel
      background : $button-del

  .button_content {
    width: 100%;
    margin: 20px 0;
    height : 100%;
    text-align: center;

    .alone_button {
      background: #00abad;
      width: 220px;
      text-align: center;
      color: #fff !important;
      border-color: transparent;
      margin-bottom: 20px;
    }

    .esc_button {
      background: #aaadb3;
      width: 220px;
      text-align: center;
      border-color: transparent;
      color: #fff !important;
      margin-bottom: 20px;
      margin-left: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// imageSelection.vue?76de8e7f